import { Skeleton } from "@mui/material";

const AccountingSkeleton = () => {
    return (
        <div className="accounting-skeleton">
            <Skeleton height={70} width="100%" />
            <Skeleton variant="text" width="30%" />
            <Skeleton variant="text" />
            <Skeleton variant="text" width="30%" />
            <Skeleton variant="text" />
            <Skeleton height={70} width="100%" />
            <div style={{ display: "flex", gap: "0.5rem" }}>
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton width="50px" height="50px" />
            </div>
            <div style={{ display: "flex", gap: "0.5rem" }}>
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton width="50px" height="50px" />
            </div>
            <div style={{ display: "flex", gap: "0.5rem" }}>
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton width="50px" height="50px" />
            </div>
            <div style={{ display: "flex", gap: "0.5rem" }}>
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton variant="text" width="15%" />
                <Skeleton width="50px" height="50px" />
            </div>
            <Skeleton height={50} width="100%" />
        </div>
    );
};

export { AccountingSkeleton };
